module.exports = __webpack_public_path__ + "media/images/icons/chevron-down-2510bfb49c51f36ac7c7a371bea6fe15.svg";